import QuestionDeleteDialog from './QuestionDeleteDialog';

export default QuestionDeleteDialog;
